import React__default, { useState, useEffect } from 'react';
import st from '../../../../../../../../../../styled-components/dist/styled-components.esm.mjs';
import { useId, SelectionSet, SelectionSetInput, SelectionSetLabel, FlexBox, Link, Button } from '@vp/swan';
import { SimpleTitle } from '../../../../../shared/simple-title/simple-title.mjs';
import { useProductOptionsTranslations } from '../../../../../product-options-translations/product-option-translations.mjs';
import { QuantityItem } from './quantity-item.mjs';

st.div `
      margin-bottom: var(--swan-spacing-standard-4);
      
      .swan-selection-set {
          gap: 16px;
          container-type: inline-size;
          container-name: productOption;
      }
`;
const WideQuantityListSkin = ({ option, locale, currency, fractionDigits, onChanged, onShowAllQuantities, showIncompatibleChoices, savingsFormat, priceDisplayMode, hasSampleQuantity, }) => {
    const [showAllQuantities, setShowAllQuantities] = useState(false);
    const titleId = useId();
    const [selectedQuantity, setSelectedQuantity] = useState(option.selectedKey);
    const { i18n } = useProductOptionsTranslations();
    useEffect(() => {
        // By storing the selection in state and updating it whe the prop changes, we
        // fix an a11y issue that prevents the radiogroup from being navigable with arrow
        // keys, but also keeps the current selection in perfect sync with the keyboard focus.
        setSelectedQuantity(option.selectedKey);
    }, [option.selectedKey]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (selectedValue, event) => {
        onChanged({ choiceKey: selectedValue });
    };
    const defaultNumOptionsShown = 5;
    const allQuantitiesHaveShown = option.choices.length <= defaultNumOptionsShown;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(SelectionSet, { style: { flexWrap: "wrap" }, variant: "single-select", selectedValue: selectedQuantity, onSelectedValueChange: onChangeHandler, "aria-labelledby": titleId }, option.choices
            .filter((choice) => showIncompatibleChoices || choice.isCompatible)
            .map((choice, index) => {
            const isSampleQuantity = hasSampleQuantity && index === 0;
            const quantitySavingsIsVisible = !isSampleQuantity && savingsFormat && savingsFormat !== "hidden";
            const onSale = (choice.totalDiscountedPrice ?? 0) < (choice.totalListPrice ?? 0);
            if (showAllQuantities ||
                index <= defaultNumOptionsShown - 1 ||
                option.selectedKey === choice.key) {
                return (React__default.createElement(SelectionSetInput, { key: `choice_${choice.key}`, value: choice.key, disabled: !choice.isCompatible, id: option.key + choice.key },
                    React__default.createElement(SelectionSetLabel, { style: { wordBreak: "initial" } },
                        React__default.createElement(QuantityItem, { choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, fractionDigits: fractionDigits, isSampleQuantity: isSampleQuantity, quantitySavingsIsVisible: quantitySavingsIsVisible, onSale: onSale, savingsFormat: savingsFormat }))));
            }
        })),
        !showAllQuantities && !allQuantitiesHaveShown && (React__default.createElement(FlexBox, { justifyContent: "center" },
            React__default.createElement(Link, { render: (p) => (React__default.createElement(Button, { skin: "link", className: p.className, onClick: () => {
                        if (onShowAllQuantities) {
                            onShowAllQuantities();
                        }
                        setShowAllQuantities(true);
                    } }, p.children)) }, i18n("seeMoreQuantities"))))));
};

export { WideQuantityListSkin };
//# sourceMappingURL=wide-quantity-list-skin.mjs.map
